/* @jsxImportSource react */

import type { FC } from 'react';

export type ProductCardV2ExtendedDescriptionProps = {
  bulletPoints?: string[];
};

export const ProductCardV2ExtendedDescription: FC<ProductCardV2ExtendedDescriptionProps> = ({
  bulletPoints,
}) => (
  <ul className="text-size-body2 product-card-extended-description mt-1 list-disc px-1 pl-5 [grid-area:10/2/span_1/span_1]">
    {bulletPoints?.map((point, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={index} className="list-item">
        {point}
      </li>
    ))}
  </ul>
);
